(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MetaTagCustom', MetaTagCustom);

    MetaTagCustom.$inject = ['$resource', 'ENV'];

    function MetaTagCustom($resource, ENV) {


        var getMetaTagsByType = function (tagType) {
            var resourceUrl = ENV.API_BASE_URL + 'api/get-meta-tags-by-type?tagType=' + tagType;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getMetaTagsByType: getMetaTagsByType
        };
    }
})();
